import React, { useState } from 'react';

const ContactForm = (props) => {
    const { submitBtnClass } = props;

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        website: '',
        message: '',
        formType: 'contact'
    });

    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('Submitting...');

        try {
            const response = await fetch('https://www.tavsftpl.com/api/send-email', {
                //const response = await fetch('http://localhost:8080/api/send-email', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (response.ok) {
                setStatus('Message sent successfully!');
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    website: '',
                    message: '',
                    formType: 'contact' 
                });
                setTimeout(() => setStatus(''), 3000);
            } else {
                setStatus(`Error: ${result.error || 'Submission failed'}`);
            }
        } catch (error) {
            console.error('Contact form error:', error);
            setStatus('Network error - please try again later');
        }
    };

    return (
        <form id="contact-form" onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6 mb-30">
                    <input
                        className="from-control"
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-md-6 mb-30">
                    <input
                        className="from-control"
                        type="email"
                        name="email"
                        placeholder="E-Mail"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-md-6 mb-30">
                    <input
                        className="from-control"
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-md-6 mb-30">
                    <input
                        className="from-control"
                        type="text"
                        name="website"
                        placeholder="Your Website"
                        value={formData.website}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-12 mb-30">
                    <textarea
                        className="from-control"
                        name="message"
                        placeholder="Your message here"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>

            <div className="btn-part">
                <button className={submitBtnClass || 'readon learn-more submit'} type="submit">
                    Submit Now
                </button>
                {status && <p className="form-status">{status}</p>}
            </div>
        </form>
    );
};

export default ContactForm;
